module.exports = {
  BASE_URL: '',
};
